/**
 * Represents a test_profile.
 */
export type TestProfileRow = {
  value: string;
  name: string;
  description: string;
  code_classification: string;
  test_groups: string[];
  test_classifications: string[];
  test_profile_versions: TestProfileVersion[];
  tests: string[];
  types: string[];
  level: string;
  version: string;
  grouping: string;
  total: string;
  applied: string;
  executed: string;
  content: string;
};

export type TestProfileVersionTest = {
  code: string;
  name: string;
  test_group: string;
};
export type TestProfileVersion = {
  version: string;
  tests: TestProfileVersionTest[];
  total_tests: number;
  new_version: boolean;
  last_used: boolean;
  description: string;
  created_at: Date;
  has_documentation: boolean;
};
/**
 * Represents a one test in test profile.
 */
export type TetsType = {
  code: string;
  name: string;
  test_classification: string;
  available: boolean;
  geospatial_input?: string;
};

export type TestThreshold = {
  value: string | null;
  description: string | null;
};

export type CountryCommodityThreshold = {
  country: string;
  commodities: {
    commodity: string;
    value: string;
    description: string | null;
  }[];
};
export type CountrySpecificThreshold = {
  country: string;
  value: string;
  description: string | null;
};

export type TestScore = {
  universal: TestThreshold;
  geospatial?: {
    polygon: TestThreshold;
    geopoint: TestThreshold;
  };
  country_specific?: CountrySpecificThreshold[];
  country_commodity?: CountryCommodityThreshold[];
};

export type TestThresholds = {
  low_score: TestScore;
  medium_score: TestScore;
  high_score: TestScore;
  critical_score: TestScore;
  countries?: {
    [country: string]: {
      universal: {
        low_score: TestThreshold;
        medium_score: TestThreshold;
        high_score: TestThreshold;
        critical_score: TestThreshold;
      };
      [commodity: string]: TestThreshold;
    };
  };
};

export type TestDetails = {
  test_group: string;
  geospatial_input: string;
  attribute_input: string[];
  test_version: number;
  risk_classification: string;
  threshold_specificity: string;
  domain: string | null;
};

export type TestDescription = {
  short_description: string;
  technical_details: string;
  background: string;
  exceptions: string;
};

export type TestProfile = {
  test_code: string;
  test_name: string;
  test_details: TestDetails;
  test_description: TestDescription;
  test_thresholds: TestThresholds;
};
/**
 * Represents a request to get tests for test_profile.
 */
export type GetTestsRequest = {
  test_profile: string;
  test_profile_version?: string;
  dataset_id?: number;
};

export type GetTestProfilesRequest = {
  commodity?: string;
};

export enum TestProfileEnumConstants {
  EUDR = 'EUDR',
}

/**
 * Represents parameters for downloading release notes.
 */
export type ReleaseNotesDownloadParams = {
  test_profile: string;
  test_profile_version?: string;
};
